import React from "react";
import { Button } from "../../ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../ui/accordion";

const Nav = ({profesorId, nombre}) => {

  return (
    <nav className="flex flex-col">
      <a href="/profesor/home">
        <Button variant="ghost" className="justify-start text-left">
          Home
        </Button>
      </a>
      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value="item-1">
          <AccordionTrigger className="inline-flex h-9 px-4 py-2 rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground">
            Record Hours
          </AccordionTrigger>
          <AccordionContent>
            <a href={`/profesor/registrarhoras`}>
            <Button variant="ghost">
              <li>Classes List</li>
            </Button>
            </a>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-2">
          <AccordionTrigger className="inline-flex h-9 px-4 py-2 rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground">
            Dashboard
          </AccordionTrigger>
          <AccordionContent>
            <a href={`/profesor/dashboard?&profesorId=${profesorId}&nombre=${nombre}`}>
            <Button variant="ghost">
              <li>View Dashboard</li>
            </Button>
            </a>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </nav>
  );
};
export default Nav;
